import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Search extends Component {

  static propTypes = {
    handleSearch: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      text: '',
    };

    // Creazione della funzione debounced
    this.handleDebouncedChange = this.debounce(this.handleDebouncedChange.bind(this), 500);
  }

  // Funzione debounce personalizzata
  debounce(func, delay) {
    let timeout;
    return function (...args) {
      const context = this;
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(context, args), delay);
    };
  }

  handleChange = (e) => {
    const value = e.target.value;
    this.setState({ text: value });
    this.handleDebouncedChange(value);
  };

  handleDebouncedChange(value) {
    // Esegui una chiamata API o un'altra operazione
    this.props.handleSearch(value);
  }

  render() {
    return (
      <div>
        <input
          type="text"
          value={this.state.text}
          onChange={this.handleChange}
          placeholder="Search sites..."
        />
        {/* <i className="icon--info" /> */}
      </div>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./app/components/Search.jsx